import { lazy } from "react";
import { Route } from "react-router-dom";
import RouteGuard from "@/components/RouteGuard";

const ProfDashboard = lazy(() => import("@/pages/ProfDashboard"));
const ProfTurmasLista = lazy(() => import("@/pages/ProfTurmasLista"));
const ProfTurmaDetalhe = lazy(() => import("@/pages/ProfTurmaDetalhe"));
const ProfSessaoAula = lazy(() => import("@/pages/ProfSessaoAula"));
const ProfAvaliacaoTecnica = lazy(() => import("@/pages/ProfAvaliacaoTecnica"));
const ProfCalendarioAulas = lazy(() => import("@/pages/ProfCalendarioAulas"));
const ProfAtividades = lazy(() => import("@/pages/ProfAtividades"));
const ProfAgendamentoAulas = lazy(() => import("@/pages/ProfAgendamentoAulas"));
const ProfAprovacoes = lazy(() => import("@/pages/ProfAprovacoes"));
const ProfConfiguracoes = lazy(() => import("@/pages/ProfConfiguracoes"));
const ProfCrmTurma = lazy(() => import("@/pages/ProfCrmTurma"));
const ProfMeusAlunos = lazy(() => import("@/pages/ProfMeusAlunos"));
const ProfRelatorioDesempenho = lazy(() => import("@/pages/ProfRelatorioDesempenho"));
const GradeHorariosAcademia = lazy(() => import("@/pages/GradeHorariosAcademia"));
const ProfMensagens = lazy(() => import("@/pages/ProfMensagens"));

const roles = ["developer", "professor"] as const;
const G = ({ children }: { children: React.ReactNode }) => (
  <RouteGuard allowedRoles={[...roles]}>{children}</RouteGuard>
);

export const professorRoutes = (
  <>
    <Route path="/prof_dashboard" element={<G><ProfDashboard /></G>} />
    <Route path="/prof_turmas" element={<G><ProfTurmasLista /></G>} />
    <Route path="/prof_turma_detalhe" element={<G><ProfTurmaDetalhe /></G>} />
    <Route path="/prof_turma/:id" element={<G><ProfTurmaDetalhe /></G>} />
    <Route path="/prof_sessao_aula" element={<G><ProfSessaoAula /></G>} />
    <Route path="/prof_avaliacao_tecnica" element={<G><ProfAvaliacaoTecnica /></G>} />
    <Route path="/prof_calendario_aulas" element={<G><ProfCalendarioAulas /></G>} />
    <Route path="/prof_atividades" element={<G><ProfAtividades /></G>} />
    <Route path="/prof_agendamento_aulas" element={<G><ProfAgendamentoAulas /></G>} />
    <Route path="/prof_aprovacoes" element={<G><ProfAprovacoes /></G>} />
    <Route path="/prof_configuracoes" element={<G><ProfConfiguracoes /></G>} />
    <Route path="/prof_crm_turma" element={<G><ProfCrmTurma /></G>} />
    <Route path="/prof_meus_alunos" element={<G><ProfMeusAlunos /></G>} />
    <Route path="/prof_relatorio_desempenho" element={<G><ProfRelatorioDesempenho /></G>} />
    <Route path="/prof_mensagens" element={<G><ProfMensagens /></G>} />
    <Route path="/grade_horarios" element={<RouteGuard allowedRoles={["developer", "professor", "admin"]}><GradeHorariosAcademia /></RouteGuard>} />
  </>
);
